import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary:    { main: "#C62828", dark: "#8B0000", contrastText: "#fff" },
    secondary:  { main: "#424242" },
    error:      { main: "#D32F2F" },
    warning:    { main: "#E65100" },
    success:    { main: "#2E7D32" },
    info:       { main: "#1565C0" },
    background: { default: "#F5F5F5", paper: "#FFFFFF" },
    text:       { primary: "#1A1A1A", secondary: "#555555" },
  },
  typography: {
    fontFamily: '"Segoe UI", Roboto, Arial, sans-serif',
    h4: { fontWeight: 700, fontSize: "1.5rem", color: "#1A1A1A" },
    h5: { fontWeight: 700, fontSize: "1.25rem" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    body1:  { fontSize: "0.9375rem", lineHeight: 1.6 },
    body2:  { fontSize: "0.875rem",  lineHeight: 1.5 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        sizeLarge: { paddingTop: 10, paddingBottom: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
      defaultProps: { elevation: 0 },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, border: "1px solid #E0E0E0" },
      },
      defaultProps: { elevation: 0 },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            backgroundColor: "#1A1A1A",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "0.825rem",
            letterSpacing: "0.02em",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "#FAFAFA" },
          "&:last-child td": { border: 0 },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "#F0F0F0", fontSize: "0.875rem" },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
    },
    MuiSelect: {
      defaultProps: { size: "small" },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});

export default theme;
